import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { UserService } from 'src/app/core';
import { CatlougeTypeConstants } from 'src/app/core/constants';
import { AssetsService } from 'src/app/core/services/assets.service';
@Component({
  selector: 'app-guruji-category',
  templateUrl: './guruji-category.component.html',
  styleUrls: ['./guruji-category.component.css']
})
export class GurujiCategoryComponent implements OnInit {
  all_list:any = [];
  constructor(public userService: UserService,public assetsService: AssetsService,public route:Router) { }

  ngOnInit(): void {
    this.getAllGuruji()
  }

  getAllGuruji() {
  
    let tabDataParams = {
      "catlogue": CatlougeTypeConstants.catlogue,
      "call": "getallfavourite",
    };
    let TabsDataParams = this.userService.convertoJSONToUrlEncoded(tabDataParams);
    this.assetsService.getAllGuruJiList(TabsDataParams).subscribe(data => {
      if(data.result.length == 1) {
        this.route.navigate(['/guruji/favourite'], { queryParams: { id: data.result[0].category_id }})
      }
      this.all_list = data.result;
    });
  }

}
